<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-warning">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-warning">
                        <span class="mdi mdi-exclamation-thick"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>¿Está seguro de que desea pausar la orden?</p>
                    </div>
                </div>
                <div class="menu-modal-main-section">
                    <div class="menu-modal-input-container">
                        <div class="menu-modal-input-container-row">
                            <div class="menu-modal-input-label">
                                Cajas producidas:
                            </div>
                            <input class="menu-modal-input-general menu-modal-input-number" type="number" min="0" step="1" :max="orderReference.real_quantity - 1" v-model="producedQuantity"/>
                        </div>
                        <div class="menu-modal-input-container-row">
                            <div class="menu-modal-input-label">
                                Cajas a producir:
                            </div>
                            <input class="menu-modal-input-general menu-modal-input-number menu-modal-input-disabled" type="number" :value="orderReference.real_quantity" disabled/>
                        </div>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button :class="isProducedQuantityOkValueClass" @click="pause" :disabled="!isProducedQuantityOkValue">Sí, pausar orden</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <WarningModal
                v-if="showWarning"
                :warningMessage="warningMessage"
                :closeWarning="closeWarning"
            />
            <PauseOrderReferenceButtonActionModalConfirm
                v-if="showConfirm"
                :orderReference="orderReference"
                :producedQuantity="producedQuantity"
                :closeConfirm="closeConfirm"
                :pauseOrderReference="pauseOrderReference"
            />
        </transition>
    </div>
</template>

<script>
import PauseOrderReferenceButtonActionModalConfirm from './PauseOrderReferenceButtonActionModalConfirm.vue';
import WarningModal from '../../../../../common/components/modals/WarningModal.vue';
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import axios from 'axios';
export default {
    name: "PauseOrderReferenceButtonActionModal",
    components: {
        WarningModal,
        PauseOrderReferenceButtonActionModalConfirm
    },
    props: {
        closeModal: {
            type: Function,
            required: true,
        },
        orderReference: {
            type: Object,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            producedQuantity: this.orderReference.produced_quantity,
            showWarning: false,
            warningMessage: '',
            showConfirm: false,
        }
    },
    methods: {
        closeWarning() {
            this.showWarning = false;
            this.warningMessage = '';
        },
        openWarning(text) {
            this.warningMessage = text;
            this.showWarning = true;
        },
        closeConfirm() {
            this.showConfirm = false;
        },
        openConfirm() {
            this.showConfirm = true;
        },
        pause() {
            this.isPauseOrderReferencePossible();
        },
        isPauseOrderReferencePossible() {
            if (this.producedQuantity < 0 || this.producedQuantity === '') {
                this.openWarning('La cantidad producida debe ser mayor o igual que 0.');
                return;
            }
            let orderReferenceId = this.orderReference.id;
            axios.get(`/api/order-reference/pause-is-possible/${orderReferenceId}/${this.producedQuantity}`)
                .then(response => {
                    let isPossibleOption = response.data.isPossibleOption;
                    switch (isPossibleOption) {
                        case 0:
                            this.openWarning(`No es posible pausar la línea de pedido con una cantidad producida igual o superior a la pedida (${this.producedQuantity}/${this.orderReference.real_quantity} cajas)`, 'info');
                            break;
                        case 1:
                            this.pauseOrderReference();
                            break;
                        case 2:
                            this.openConfirm();
                            break;
                        case 3:
                            this.pauseOrderReference();
                            break;
                        default:
                            this.openWarning('No es posible pausar la línea de pedido debido a una opción inesperada ' + isPossibleOption, 'warning');
                            break;
                    }
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        pauseOrderReference() {
            this.endOfAction();
            this.closeModal();
            let formData = {
                producedQuantity: this.producedQuantity,
                orderReferenceId: this.orderReference.id,
            }
            axios.patch(`/api/order-reference/pause`, formData)
                .then(response => {
                    showCustomSuccessSweetAlert('La tarjeta ha sido pausada correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
    },
    computed: {
        isProducedQuantityOkValue() {
            return this.producedQuantity >= 0 && this.producedQuantity < this.orderReference.real_quantity;
        },
        isProducedQuantityOkValueClass() {
            return this.isProducedQuantityOkValue ? 'menu-modal-btn menu-modal-confirm-btn' : 'menu-modal-btn menu-modal-confirm-btn-disabled';
        },
    }
};
</script>